module.exports = __webpack_public_path__ + "img/google-maps-icon.73c2375e.png";